import * as React from 'react'
import AllContentTab from './ContentTabs/AllContentTab';
import ArticlesTab from './ContentTabs/ArticlesTab';
import EventTab from './ContentTabs/EventTab';
import OtherTab from './ContentTabs/OtherTab';
import VideoTab from './ContentTabs/VideoTab';
import {HomePageContentTabs} from './HomePageContentTabs';
import store from 'src/storeWire';
class CommonContent {
    static chain = {
        HomePageContentTab: {param_value: 'ALCT', element: HomePageContentTabs}
    };
    static param_key = '__c_HomePageContent';
    static redux_key = 'HomePageContent__Component__Loader';
    static default_component = CommonContent.chain.HomePageContentTab;
cl
    static chain_HomePageContentTabList = {
        ALCT: {
            name: 'All Content',
            param_value: 'ALCT',
            element: AllContentTab,
            store: () => {
                return CommonContent.getContentTabValueFromStore('all')
            }
        },
        ACL: {
            name: 'Articles',
            param_value: 'ACL',
            element: ArticlesTab,
            store: () => {
                return CommonContent.getContentTabValueFromStore('articles')
            }
        },
        EVT: {
            name: 'Events',
            param_value: 'EVT',
            element: EventTab,
            store: () => {
                return CommonContent.getContentTabValueFromStore('events')
            }
        },
        OTR: {
            name: 'Other',
            param_value: 'OTR',
            element: OtherTab,
            store: () => {
                return CommonContent.getContentTabValueFromStore('sitePages')
            }
        },
        VDO:{
            name: 'Videos',
            param_value: 'VDO',
            element: VideoTab,
            store: () => {
                return CommonContent.getContentTabValueFromStore('video')
            }
        }
    };

    static getContentTabValueFromStore(api_fetch_type) {
        let s = store.getState();
        if (s.entities.model_HomePageContent.contentTabCount !== undefined &&
            s.entities.model_HomePageContent.contentTabCount[api_fetch_type] !== undefined
        ) {
            return {
                count: s.entities.model_HomePageContent.contentTabCount[api_fetch_type]
            };
        }
        return {
            count: 0
        };
    }

    static param_key_HomePageContentTabList = '__c_HomePageContentTabList';
    static redux_key_HomePageContentTabList = 'HomePageContentTabList__Component__Loader';
    static default_component_HomePageContentTabList = CommonContent.chain_HomePageContentTabList.ALCT;
}

export default CommonContent;